import { render } from "./SetupHome.vue?vue&type=template&id=6821c8e0&scoped=true"
import script from "./SetupHome.vue?vue&type=script&lang=js"
export * from "./SetupHome.vue?vue&type=script&lang=js"

import "./SetupHome.vue?vue&type=style&index=0&id=6821c8e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6821c8e0"]])

export default __exports__